import { Routes, mapToResolve } from '@angular/router';
import { ReportComponent } from './components/report/report.component';
import { ReportResolver } from './resolvers/report.resolver';
import { LoginAuthComponent } from './login-auth/login-auth.component';

export const REPORT_ROUTES: Routes = [
    {
        path: "login-audit",
        component: LoginAuthComponent,
    },
    {
        path: ":id",
        component: ReportComponent,
        resolve: { workflow: mapToResolve(ReportResolver) }
    }


];
